// need export to ensure its only initialized once
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { getApplicationInsightsConnectionString } from "./api/secretsApi";

let appInsights;

async function createApplicationInsightsInstance(email) {
  try {
    if (
      !appInsights &&
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/unexpectedError"
    ) {
      try {
        var connectionString = await getApplicationInsightsConnectionString();
      } catch (error) {
        console.log(error);
        return null;
      }
      appInsights = new ApplicationInsights({
        config: {
          connectionString: connectionString,
          enableAutoRouteTracking: true,
          disableFetchTracking: true,
          disableAjaxTracking: true,
          enableRequestHeaderTracking: false,
          enableResponseHeaderTracking: false,
        },
      });

      appInsights.loadAppInsights();

      try {
        if (email) {
          appInsights.setAuthenticatedUserContext(email);
        }
      } catch (error) {
        appInsights.trackException({ error });
      }
    }
    return appInsights;
  } catch (error) {
    console.error(error);
    //In the event there is some issue with app insights we don't want to break the application
  }
}

// Call this function to get the Application Insights instance
export const getAppInsights = async (email) => {
  return appInsights || (await createApplicationInsightsInstance(email));
};

/**
 * The instance that already exists, or undefined when nothing has created one yet.
 *
 * Deliberately does NOT create one, and that is the whole point of it existing (AKL-798).
 * `getAppInsights(email)` sets the authenticated user context from its argument, so a caller
 * that does not have an email yet — the Report a problem dialog, which can open before
 * `/users/me` has resolved — would build and cache the client with NO authenticated user, and
 * every later page view and exception in that browser session would be recorded without a
 * user id. It also fetches the connection string over the shared axios client, so a caller
 * that only wants to read telemetry state could trigger a request (and, on a dead API, get
 * that request recorded as the "last failed request"). Read-only callers use this instead.
 * @returns the Application Insights instance, or undefined
 */
export const peekAppInsights = () => appInsights;

export const clearAuthenticatedUserContext = async () => {
  const ai = await getAppInsights();
  if (ai) {
    ai.clearAuthenticatedUserContext();
    ai.flush(); // Send all telemetry before the user logs out
  }
};
